<template>
  <div tabindex="0" @keydown.esc="mthClearEditmodeFlags">
    <CCard></CCard>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <h1>
              Edycja produktu
              <b>{{ formData[8].value }}</b>
            </h1>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12">
                <div md="12"></div>
                <br />

                <CRow>
                  <CCol sm="12">
                    <table class="table">
                      <tbody>
                        <tr
                          v-bind:key="field.label"
                          class="productdetailsField"
                          v-for="(field, index) in formData"
                        >
                          <!-- label cell, caption, row header -->
                          <td
                            class="datacell"
                            scope="col"
                            width="30%"
                            :title="index"
                          >
                            {{ field.label }}
                          </td>

                          <td class="bold bigger datacell" scope="col">
                            <!-- READ-ONLY -->
                            <span
                              v-if="
                                !field.editMode &&
                                (field.type == 'txt' || field.type == 'num')
                              "
                              @click="mthSwitchToEdit(index)"
                              class="editable"
                            >
                              {{ field.prefix }}{{ field.value }}
                              <span class="light">{{
                                mthPlaceholderForEmptyValue(field.value)
                              }}</span>
                            </span>
                            <!-- CHECKBOX -->
                            <span v-else-if="field.type == 'checkbox'">
                              <input
                                @change="mthEditLabelSendToDB(index)"
                                type="checkbox"
                                v-bind:true-value="1"
                                v-bind:false-value="0"
                                v-model="field.value"
                              />
                            </span>
                            <!-- TEXTBOX -->
                            <span
                              v-else-if="
                                field.type == 'txt' || field.type == 'num'
                              "
                            >
                              <input
                                v-on:keyup.enter="mthEditLabelSendToDB(index)"
                                type="text"
                                v-model="field.value"
                              />
                            </span>
                            <!-- rich text -->
                            <span v-else-if="field.type == 'richtxt'">
                              <VueEditor
                                v-model="field.value"
                                @text-change="handleVueEditorTextChangeDebounce(index)"
                              />
                            </span>
                            <!-- image -->
                            <span v-else-if="field.type == 'img'">
                              <table>
                                <tr>
                                  <td width="120">
                                    <img
                                      :key="refresher"
                                      width="120"
                                      :src="mthPreprocessImg(field.value)"
                                    />
                                  </td>
                                  <td width="300">
                                    <!-- IMG_UPLOAD_URL: 'http://gardenpartslen.pl/commonFileDownload.php', -->
                                    <file-upload
                                      :url="mthFileUploadUrl()"
                                      :thumb-url="mthVFileUploadThumbUrl"
                                      :headers="headers"
                                      @change="mthVFileUploadFileChange"
                                      @success="mthVFileUploadFileSuccess"
                                      @error="mthVFileUploadFileError"
                                      @progress="mthVFileUploadFileProgress"
                                      btn-label="Załaduj plik"
                                      btn-uploading-label="Trwa wysyłanie pliku"
                                    ></file-upload>
                                  </td>
                                </tr>
                                <tr></tr>
                              </table>
                            </span>
                            <!-- tree locations by id -->
                            <span v-else-if="field.type == 'treelocationsbyid'">
                              <tree-locations-by-product-id
                                :productid="$router.history.current.params.id"
                              ></tree-locations-by-product-id>
                            </span>
                          </td>
                          <td class="narrow datacell">{{ field.suffix }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import MainChartExample from "./charts/MainChartExample";
import WidgetsDropdown from "./widgets/WidgetsDropdown";
import WidgetsBrand from "./widgets/WidgetsBrand";
import CTableWrapper from "./base/Table.vue";
import TreeLocationsByProductId from "./b2bisz/TreeLocationsByProductId.vue";
import { VueEditor } from "vue2-editor";
import _ from "lodash";

export default {
  name: "b2bproductDetails",
  components: {
    MainChartExample,
    WidgetsDropdown,
    WidgetsBrand,
    CTableWrapper,
    TreeLocationsByProductId,
    VueEditor,
  },
  mounted() {
    this.mthFillData();
  },
  data() {
    return {
      refresher: 0,
      headers: { "access-token": "<your-token>" },
      searchValue: "",
      ordersData: [],
      includeTreeID: [3, 4, 5, 6, 7, 9], //rows that need treeID as a DBkey1_value in them
      formData: [
        {
          label: "ID produktu",
          editable: false,
          visible: true,
          DBtable: "katalog_products",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "id",
          value: "",
          suffix: "",
          prefix: "",
          type: "txt",
          editMode: false,
        },
        {
          label: "ID miejsca w drzewie produktów",
          editable: false,
          visible: true,
          DBtable: "katalog_products",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "tree_id",
          value: "",
          suffix: "",
          prefix: "",
          type: "txt",
          editMode: false,
        },
        {
          label: "Elementy nadrzędne",
          editable: true,
          visible: true,
          DBtable: "katalog_tree_products",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "tree_id",
          value: "",
          suffix: "",
          prefix: "",
          type: "treelocationsbyid",
          editMode: false,
        },
        {
          label: "Nazwa PL",
          editable: true,
          DBtable: "katalog_nazwa",
          DBkey1_name: "tree_id",
          DBkey1_value: 0,
          DBkey2_name: "lang_id",
          DBkey2_value: 1,
          DBfield: "text",
          value: "",
          suffix: "",
          prefix: "",
          type: "txt",
          editMode: false,
        },
        {
          label: "Opis PL (tekst zapisuje się automatycznie)",
          editable: true,
          DBtable: "katalog_opis",
          DBkey1_name: "tree_id",
          DBkey1_value: 0,
          DBkey2_name: "lang_id",
          DBkey2_value: 1,
          DBfield: "text",
          value: "",
          suffix: "",
          prefix: "",
          type: "richtxt",
          editMode: false,
        },
        {
          label: "Nazwa CZ",
          editable: true,
          DBtable: "katalog_nazwa",
          DBkey1_name: "tree_id",
          DBkey1_value: 0,
          DBkey2_name: "lang_id",
          DBkey2_value: 2,
          DBfield: "text",
          value: "",
          suffix: "",
          prefix: "",
          type: "txt",
          editMode: false,
        },
        {
          label: "Opis CZ",
          editable: true,
          DBtable: "katalog_opis",
          DBkey1_name: "tree_id",
          DBkey1_value: 0,
          DBkey2_name: "lang_id",
          DBkey2_value: 2,
          DBfield: "text",
          value: "",
          suffix: "",
          prefix: "",
          type: "richtxt",
          editMode: false,
        },
        {
          label: "Nazwa SK",
          editable: true,
          DBtable: "katalog_nazwa",
          DBkey1_name: "tree_id",
          DBkey1_value: 0,
          DBkey2_name: "lang_id",
          DBkey2_value: 3,
          DBfield: "text",
          value: "",
          suffix: "",
          prefix: "",
          type: "txt",
          editMode: false,
        },
        {
          label: "Opis SK",
          editable: true,
          DBtable: "katalog_opis",
          DBkey1_name: "tree_id",
          DBkey1_value: 0,
          DBkey2_name: "lang_id",
          DBkey2_value: 3,
          DBfield: "text",
          value: "",
          suffix: "",
          prefix: "",
          type: "richtxt",
          editMode: false,
        },
        {
          label: "Nazwa HU",
          editable: true,
          DBtable: "katalog_nazwa",
          DBkey1_name: "tree_id",
          DBkey1_value: 0,
          DBkey2_name: "lang_id",
          DBkey2_value: 5,
          DBfield: "text",
          value: "",
          suffix: "",
          prefix: "",
          type: "txt",
          editMode: false,
        },
        {
          label: "Opis HU",
          editable: true,
          DBtable: "katalog_opis",
          DBkey1_name: "tree_id",
          DBkey1_value: 0,
          DBkey2_name: "lang_id",
          DBkey2_value: 5,
          DBfield: "text",
          value: "",
          suffix: "",
          prefix: "",
          type: "richtxt",
          editMode: false,
        },
        {
          label: "Nazwa RO",
          editable: true,
          DBtable: "katalog_nazwa",
          DBkey1_name: "tree_id",
          DBkey1_value: 0,
          DBkey2_name: "lang_id",
          DBkey2_value: 6,
          DBfield: "text",
          value: "",
          suffix: "",
          prefix: "",
          type: "txt",
          editMode: false,
        },
        {
          label: "Opis RO",
          editable: true,
          DBtable: "katalog_opis",
          DBkey1_name: "tree_id",
          DBkey1_value: 0,
          DBkey2_name: "lang_id",
          DBkey2_value: 6,
          DBfield: "text",
          value: "",
          suffix: "",
          prefix: "",
          type: "richtxt",
          editMode: false,
        },
        {
          label: "Numer Katalogowy",
          editable: true,
          DBtable: "katalog_products",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "nr_kat",
          value: "",
          suffix: "",
          prefix: "",
          type: "txt",
          editMode: false,
        },
        {
          label: "Obrazek",
          editable: true,
          DBtable: "katalog_media",
          DBkey1_name: "tree_id",
          DBkey1_value: "",
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "src",
          value: "",
          suffix: "",
          prefix: "",
          type: "img",
          editMode: false,
        },
        {
          label: "Cena (PLN netto)",
          editable: true,
          DBtable: "katalog_products",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "cena",
          value: "",
          suffix: " PLN netto",
          prefix: "",
          type: "num",
          editMode: false,
        },
        {
          label: "Cena (PLN brutto)",
          editable: true,
          DBtable: "katalog_products",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "cenaBrutto",
          value: "",
          suffix: " PLN brutto",
          prefix: "",
          type: "num",
          editMode: false,
        },
        {
          label: "Firma",
          editable: true,
          DBtable: "katalog_products",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "firma",
          value: "",
          suffix: "",
          prefix: "",
          type: "txt",
          editMode: false,
        },
        {
          label: "Marka",
          editable: true,
          DBtable: "katalog_products",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "marka",
          value: "",
          suffix: "",
          prefix: "",
          type: "txt",
          editMode: false,
        },
        {
          label: "Hurt - ilość sztuk w opakowaniu",
          editable: true,
          DBtable: "katalog_products",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "opakHurtSzt",
          value: "",
          suffix: "",
          prefix: "",
          type: "num",
          editMode: false,
        },
        {
          label: "Hurt - cena netto za opakowanie (PLN)",
          editable: true,
          DBtable: "katalog_products",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "cenaHurtNetto",
          value: "",
          suffix: "PLN netto",
          prefix: "",
          type: "num",
          editMode: false,
        },
        {
          label: "Numer oryginalny",
          editable: true,
          DBtable: "katalog_products",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "nr_oryginalny",
          value: "",
          suffix: "",
          prefix: "",
          type: "txt",
          editMode: false,
        },
        {
          label: "Oferta specjalna",
          editable: true,
          DBtable: "katalog_products",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "special",
          value: "",
          suffix: "",
          prefix: "",
          type: "checkbox",
          editMode: false,
        },
        {
          label: "Dostawca",
          editable: true,
          DBtable: "katalog_products",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "dostawca",
          value: "",
          suffix: "",
          prefix: "",
          type: "txt",
          editMode: false,
        },
        {
          label: "Nr kat. u dostawcy",
          editable: true,
          DBtable: "katalog_products",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "nr_kat_dostawcy",
          value: "",
          suffix: "",
          prefix: "",
          type: "txt",
          editMode: false,
        },
        {
          label: "Stan w magazynie",
          editable: false,
          DBtable: "katalog_products",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "stan_cache",
          value: "",
          suffix: "",
          prefix: "",
          type: "num",
          editMode: false,
        },
        {
          label: "Sprzedano w ost. 12 miesiącach",
          editable: false,
          DBtable: "katalog_products",
          DBkey1_name: "id",
          DBkey1_value: this.$router.history.current.params.id,
          DBkey2_name: "",
          DBkey2_value: "",
          DBfield: "ilosc_swco12mcy",
          value: "",
          suffix: "",
          prefix: "",
          type: "num",
          editMode: false,
        },
        //brutto oraz wartosci logiczne (checkbox) todo
      ],
    };
  },
  created() {
    console.log(this.$router);
    //console.log(this.$router.history.current.params.id);
  },
  methods: {
    handleVueEditorTextChangeDebounce: _.debounce(function (index) {
      this.mthVueEditorTextChange(index);
    }, 1000),
    mthVueEditorTextChange(index) {
      this.mthEditLabelSendToDB(index);
    },
    mthFileUploadUrl() {
      return (
        process.env.VUE_APP_IMG_UPLOAD_URL +
        "?id=" +
        this.$router.history.current.params.id +
        "&toname=" +
        this.formData[8].value
      );
    },
    mthPlaceholderForEmptyValue(value) {
      //if value is empty, there is no place to click for edit...
      if (value == "") return "(pole jest puste, kliknij aby edytować(3))";
      return "";
    },
    mthVFileUploadThumbUrl() {},
    mthVFileUploadFileChange() {},
    mthVFileUploadFileSuccess() {
      var miliseconds = new Date().getTime();
      this.refresher = miliseconds;
      this.mthFillFormData2();
    },
    mthVFileUploadFileError() {},
    mthVFileUploadFileProgress() {},
    mthPreprocessImg(src) {
      var ret = src;
      ret = process.env.VUE_APP_GP_URL + src + "?nocache=" + this.refresher;
      return ret;
    },
    mthClearEditmodeFlags() {
      //this.formData.each(function(index,item){item.editMode=false;});

      this.formData.forEach((element) => {
        element.editMode = false;
      });
    },
    mthSwitchToEdit(index) {
      this.mthClearEditmodeFlags();

      if (this.formData[index].editable) this.formData[index].editMode = true;
    },
    mthEditLabelSendToDB(index) {
      var that = this;
      var data = this.formData[index];
      if (data.type == "checkbox") {
      }
      if (data.type == "num") {
        data.value.replace(".", ",");
      }
      var apiurl =
        process.env.VUE_APP_API_URL +
        "/b2bsetattrvalfromtbl?tbln=" +
        data.DBtable +
        "&key1n=" +
        data.DBkey1_name +
        "&key1v=" +
        data.DBkey1_value +
        "&key2n=" +
        data.DBkey2_name +
        "&key2v=" +
        data.DBkey2_value +
        "&fieldn=" +
        data.DBfield +
        "&data=" +
        encodeURIComponent(data.value) +
        "&index=" +
        index +
        "&datatype=" +
        data.type;

      const options = { method: "get", url: apiurl };
      this.$axios(options)
        .then(function (response) {
          that.formData[index].editMode = false;
          that.mthFillFormData2();
        })
        .catch(function (error) {
          that.loginsuccess = false;
          that.loginresultmsg = "Brak połączenia z API (" + error + ").";
        });
    },
    mthFillFormData2() {
      var data;
      var section = "";
      var that = this;

      var requestsArray = [];

      this.formData.forEach(function (item, index) {
        var apiurl =
          process.env.VUE_APP_API_URL +
          "/api/v1/b2bgetattrvalfromtbl?tbln=" +
          item.DBtable +
          "&key1n=" +
          item.DBkey1_name +
          "&key1v=" +
          item.DBkey1_value +
          "&key2n=" +
          item.DBkey2_name +
          "&key2v=" +
          item.DBkey2_value +
          "&fieldn=" +
          item.DBfield +
          "&index=" +
          index;

        requestsArray.push(that.$axios.get(apiurl));
      });

      //magic, multiple requests with axios
      console.log("requesty");
      console.log(requestsArray);

      that.$axios
        .all(requestsArray)
        .then(
          that.$axios.spread((...responses) => {
            responses.forEach((r) => {
              if (r.data.value == "") return;
              that.formData[r.data.index].value = r.data.value;
            });
          })
        )
        .catch((errors) => {
          console.log(errors);
        });
      //end of magic
    },
    // mthFillFormData() {
    //   var data;
    //   var section = "";
    //   var that = this;

    //   //var formdata2=this.formData;
    //   //for (var i = 0; i < this.formData.length; i++) {
    //   this.formData.forEach(function (item, index) {
    //     //zaladuj id do tablic
    //     var apiurl =
    //       process.env.VUE_APP_API_URL +
    //       "/api/v1/b2bgetattrvalfromtbl?tbln=" +
    //       item.DBtable +
    //       "&key1n=" +
    //       item.DBkey1_name +
    //       "&key1v=" +
    //       item.DBkey1_value +
    //       "&key2n=" +
    //       item.DBkey2_name +
    //       "&key2v=" +
    //       item.DBkey2_value +
    //       "&fieldn=" +
    //       item.DBfield +
    //       "&index=" +
    //       index;

    //     that
    //       .$axios({
    //         method: "get",
    //         url: apiurl,
    //       })
    //       .then(function (response) {
    //         if (response.data.value == "") return;
    //         that.formData[response.data.index].value = response.data.value;
    //       })
    //       .catch(function (error) {
    //         console.log(error);
    //         that.loginsuccess = false;
    //         that.loginresultmsg = "Brak połączenia z API (" + error + ").";
    //       });
    //   }); //forEach
    // },
    shuffleArray(array) {
      for (let i = array.length; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
      return false;
    },

    getShuffledOrdersData() {
      return this.shuffleArray(this.ordersData.slice(0));
    },
    mthFillData() {
      //zaladuj id do tablic
      var apiurl =
        process.env.VUE_APP_API_URL +
        "/api/v1/b2bgetattrvalfromtbl?tbln=katalog_products&key1n=id" +
        "&key1v=" +
        this.$router.history.current.params.id +
        "&key2n=&key2v=&fieldn=tree_id";

      var that = this;
      this.$axios({
        method: "get",
        url: apiurl,
      })
        .then(function (response) {
          //fill treeID
          for (let i = 0; i < that.includeTreeID.length; i++) {
            var rowNum = that.includeTreeID[i];
            that.formData[rowNum].DBkey1_value = response.data.value;
          }
          that.mthFillFormData2();
        })
        .catch(function (error) {
          console.log(error);
          that.loginsuccess = false;
          that.loginresultmsg = "Brak połączenia z API (" + error + ").";
        });
    },
    color(value) {
      let $color;
      if (value <= 25) {
        $color = "info";
      } else if (value > 25 && value <= 50) {
        $color = "success";
      } else if (value > 50 && value <= 75) {
        $color = "warning";
      } else if (value > 75 && value <= 100) {
        $color = "danger";
      }
      return $color;
    },
  },
};
</script>

<style scoped>
@import "./styles/products.css";
input[type="text"] {
  width: 100%;
  background-color: yellow;
  height: 100%;
}
.bold {
  font-weight: bold;
}
.bigger {
  font-size: 14pt;
}
.datacell {
  padding-top: 4px;
}
.narrow {
  width: 12%;
}
.imgcell {
  display: inline;
}
.light {
  color: lightgray;
}
</style>
